export default "__VITE_ASSET__CBN6oFAw__"